import { Outlet, useOutletContext } from "react-router-dom";

import { FlowDndProvider } from "src/flowsOverview/v2/FlowDndProvider";
import { DashboardContent } from "src/layout/DashboardContent";
import { MainSideBar } from "src/mainPage/MainSideBar";
import { DashboardPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const MainPageDashboard: React.FC = () => {
  const context = useOutletContext();
  const { wsId } = useParamsDecode<DashboardPageParams>();

  return (
    <FlowDndProvider workspaceId={wsId}>
      <DashboardContent sidebar={<MainSideBar />} removePadding>
        <Outlet context={context} />
      </DashboardContent>
    </FlowDndProvider>
  );
};
